import React, { useState, useEffect } from "react";
import VideoModal from "../components/VideoModal";
import "../styles/Pages.css";
import "../styles/HariParamrut.css";

function EuropeYatra() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [selectedVideoTitle, setSelectedVideoTitle] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          //  "http://dbphp.prabodhswamiji.in/dbihariprabodham.php?category=12",
          "https://hariprabodham.org.in/api/?category=12",
        );
        if (!response.ok) {
          throw new Error("Failed to fetch videos");
        }
        const data = await response.json();

        // Transform the data to match our format
        const transformedVideos = data.map((video) => ({
          id: video.VideoUrl.replace("https://www.youtube.com/watch?v=", ""),
          title: video.Title,
          location: video.City || "",
        }));

        setVideos(transformedVideos);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching videos:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const openVideoModal = (videoId, title) => {
    setSelectedVideoId(videoId);
    setSelectedVideoTitle(title);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideoId(null);
    setSelectedVideoTitle(null);
  };

  return (
    <main className="page-content pravachan-page">
      <section className="page-header">
        <h1 className="section-title">
          Europe Yatra
          {!loading && !error && (
            <span
              style={{ fontSize: "1rem", marginLeft: "12px", color: "#888" }}
            >
              ({videos.length})
            </span>
          )}
        </h1>
        <p className="header-subtitle">Europe Yatra Pravachan</p>
      </section>

      <section className="page-body">
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading videos...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <p>Error loading videos: {error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        )}

        {!loading && !error && (
          <div className="video-grid">
            {videos.map((video, index) => (
              <div
                key={index}
                className="video-card"
                onClick={() => openVideoModal(video.id, video.title)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.key === "Enter") openVideoModal(video.id, video.title);
                }}
              >
                <div className="video-thumbnail">
                  <img
                    src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                    alt={video.title}
                  />
                  <div className="play-overlay">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
                <div className="video-info">
                  <h3>{video.title}</h3>
                  {video.location && (
                    <p className="video-location">{video.location}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {isModalOpen && (
        <VideoModal
          videoId={selectedVideoId}
          title={selectedVideoTitle}
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      )}
    </main>
  );
}

export default EuropeYatra;
